export const GET_OUTLET_REQUEST = 'GET_OUTLET_REQUEST'
export const GET_OUTLET_SUCCESS = 'GET_OUTLET_SUCCESS'
export const GET_OUTLET_FALIURE = 'GET_OUTLET_FALIURE'
export const ENABLE_OUTLET_REQUEST = 'ENABLE_OUTLET_REQUEST'
export const ENABLE_OUTLET_SUCCESS = 'ENABLE_OUTLET_SUCCESS'
export const ENABLE_OUTLET_FALIURE = 'ENABLE_OUTLET_FALIURE'
export const DELETE_OUTLET_REQUEST = 'DELETE_OUTLET_REQUEST'
export const DELETE_OUTLET_SUCCESS = 'DELETE_OUTLET_SUCCESS'
export const DELETE_OUTLET_FALIURE = 'DELETE_OUTLET_FALIURE'
